// src/components/aiTalentDrive/useRevealOnScroll.ts
// Reveals .hc-fade / .hc-stagger blocks inside `rootRef` as they scroll into
// view, by adding the "visible" class (see hiring-circuit.css). Same pattern
// as the MTW page. Blocks are shown at once where IntersectionObserver is
// missing.
import { RefObject, useEffect } from "react";

export default function useRevealOnScroll(rootRef: RefObject<HTMLElement | null>) {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const targets = root.querySelectorAll(".hc-fade, .hc-stagger");
    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("visible"));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [rootRef]);
}
